const fa = {
  100000001:'اطلاعات کلیدی',
  100000002:'نام توکن',
  100000003:'سازنده کپی',
  100000004:'زمان ایجاد نمونه',
  100000005:"اطلاعات پایه",
  100000006:'بلاکچین/پروتکل مرتبط',
  100000007:'آدرس قرارداد هوشمند',
  100000008:'تاریخ صدور',
  100000009:'عرضه کل',
  100000010:'تامین گردش',
  100000011:'ارزش بازار',
  100000012:'اطلاعات',
  100000013:'اطلاعات شبکه‌های اجتماعی',
  100000014:'وب سایت',
  100000015:'وایت پیپر',
  100000016:'مرورگر بلاکچین',
  100000017:'امتیاز پروژه',
  100000018:'رتبه بندی ',
  100000019:'برتر',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'زمان به روز شد',
  100000027:'امتیاز امنیت',
  100000028:'امتیاز امنیت قرارداد',
  100000029:'آمار پروژه‌های پرخطر',
  100000030:'جزئیات کد قرارداد',
  100000031:'مالیات خرید',
  100000032:'مالیات فروش',
  100000033:'آیا هانی‌پات است',
  100000034:'آیا می‌توان دوباره Mint کرد',
  100000035:'آیا لیست سیاه وجود دارد',
  100000036:'آیا لیست سفید وجود دارد',
  100000037:'آیا ضد نهنگ است',
  100000038:'آیا می‌توان نرخ مالیات را تغییر داد',
  100000039:'آیا متن‌باز است',
  100000040:'آیا دارنده‌های پنهان وجود دارند',
  100000041:'آیا می‌توان خود را نابود کرد',
  100000042:'آیا قرارداد پراکسی است',
  100000043:'آیا می‌توان موجودی را تغییر داد',
  100000044:'آیا می‌توان فراخوانی خارجی انجام داد',
  100000045:'آیا می‌توان مالکیت را دوباره به دست آورد',
  100000046:'آیا دوره سرد برای تراکنش‌ها وجود دارد',
  100000047:'آیا می‌توان انتقال را متوقف کرد',
  100000048:'مالکیت رها نشده است',
  100000049:'آیا ضد نهنگ قابل تنظیم است',
  100000050:'تعداد اعشار بیش از حد است',
  100000051:'روش‌های Mint و Burn عمومی',
  100000052:'آیا سوزاندن توکن‌ها مقدار کل را به‌روز می‌کند',
  100000053:'آیا سوزاندن توکن‌ها موجودی را به‌روز می‌کند',
  100000054:'آیا انتقال به خود باعث افزایش موجودی می‌شود',
  100000055:'آیا انتقال توکن بیش از موجودی نامعتبر خواهد بود',
  100000056:'موجودی در طول انتقال به‌روز نمی‌شود',
  100000057:'آیا موجودی گیرنده مصرف می‌شود',
  100000058:'آیا هنگام فراخوانی TransferFrom بیش از موجودی شکست می‌خورد',
  100000059:'آیا روش BurnFrom مقدار کل را به‌روز می‌کند',
  100000060:'تشخیص مالیات خرید توکن بالای ۵٪ به عنوان نرخ مالیات بالا در نظر گرفته می‌شود',
  100000061:'تشخیص مالیات فروش توکن بالای ۵٪ به عنوان نرخ مالیات بالا در نظر گرفته می‌شود',
  100000062:'بررسی کنید که آیا توکن یک کلاهبرداری هانی‌پات است',
  100000063:'بررسی کنید که آیا می‌توان توکن‌های بیشتری ضرب کرد',
  100000064:'بررسی کنید که آیا توکن لیست سیاهی دارد که می‌تواند کاربران را از مبادله یا انتقال توکن‌ها محدود کند',
  100000065:'بررسی کنید که آیا توکن لیست سفیدی دارد که به آدرس‌ها اجازه می‌دهد هر گونه محدودیتی را دور بزنند',
  100000066:'بررسی کنید که آیا توکن مکانیزم ضد نهنگ دارد',
  100000067:'بررسی کنید که آیا توکن مالیات دارد و آیا مالیات توسط نقش‌های ویژه قابل تغییر است',
  100000068:'بررسی کنید که آیا توکن در مرورگر بلاک‌چین تأیید شده است',
  100000069:'بررسی کنید که آیا توکن یک مالک پنهان دارد که می‌تواند قرارداد را دستکاری کند حتی اگر به نظر می‌رسد مالکیت لغو شده است',
  100000070:'بررسی کنید که آیا توکن می‌تواند خود را نابود کند',
  100000071:'بررسی کنید که آیا توکن یک قرارداد پروکسی است که تماس‌های تابع را به یک قرارداد پیاده‌سازی می‌سپارد',
  100000072:'بررسی کنید که آیا موجودی توکن می‌تواند توسط نقش‌های ویژه تغییر کند',
  100000073:'بررسی کنید که آیا توکن قراردادهای خارجی را فراخوانی می‌کند',
  100000074:'بررسی کنید که آیا توکن یک در پشتی برای بازپس‌گیری مالکیت دارد',
  100000075:'بررسی کنید که آیا توکن مکانیزم تأخیر انتقال دارد',
  100000076:'بررسی کنید که آیا تجارت توکن می‌تواند توسط نقش‌های ویژه متوقف شود',
  100000077:'بررسی کنید که آیا امتیاز مالک لغو شده است',
  100000078:'بررسی کنید که آیا مکانیزم‌های ضد نهنگ توکن می‌تواند توسط نقش‌های ویژه تغییر کند',
  100000079:'بررسی کنید که آیا مقدار بازگشتی تابع decimals() بیشتر یا مساوی ۵ است',
  100000080:'بررسی کنید که آیا فراخوانی توابع mint() و burn() توسط کاربران تصادفی منجر به برگشت می‌شود',
  100000081:'بررسی کنید که آیا فراخوانی تابع burn() میزان totalSupply را به درستی به‌روزرسانی می‌کند',
  100000082:"بررسی کنید که آیا فراخوانی تابع burnFrom() میزان تخصیص را به درستی به‌روزرسانی می‌کند",
  100000083:'بررسی کنید که آیا فراخوانی تابع transfer() با گیرنده‌ای که همان فرستنده تراکنش است، موجودی فرستنده را افزایش می‌دهد',
  100000084:'بررسی کنید که آیا فراخوانی تابع transfer() با مقداری بیشتر از موجودی منجر به شکست می‌شود',
  100000085:"بررسی کنید که آیا پس از فراخوانی تابع transferFrom()، تخصیص هزینه‌کننده به درستی به‌روزرسانی می‌شود",
  100000086:"بررسی کنید که آیا فراخوانی تابع transferFrom() از موجودی هزینه‌کننده استفاده می‌کند",
  100000087:"بررسی کنید که آیا پس از فراخوانی transferFrom()، مقدار مجاز به‌درستی به‌روزرسانی شده است یا اگر مقدار نامعتبر باشد، تراکنش بازگردانده می‌شود.",
  100000088:"بررسی کنید که آیا فراخوانی تابع burnFrom() باعث به‌روزرسانی صحیح totalSupply می‌شود.",
  100000089:'بررسی کنید که آیا اختیارات ضرب سکه وجود دارد',
  100000090:'بررسی کنید که آیا اختیارات مسدود‌سازی وجود دارد',
  100000091:'بررسی کنید که آیا متادیتا قابل تغییر است',
  100000092:'حرج',
  100000093:'كبير',
  100000094:'متوسط',
  100000095:'ثانوي',
  100000096:'إعلامي',
  100000097:'آیا مجوز mint رها شده است',
  100000098:'آیا مجوز انجماد رها شده است',
  100000099:'آیا می‌توان فراداده‌های توکن را تغییر داد',

  100000100:'گزارش سالانه شما در حال محاسبه است…',
  100000101:'خوش آمدید',
  100000102:'بررسی شما در سال 2024',
  100000103:'من راهنمای شخصی شما هستم',
  100000104:'اینجاست تا شما را از ردپای سفر 2024 خود بگذرانیم',
  100000105:'گزارش را باز کنید',
  100000106:'{num} روز پیش، چرخ های سرنوشت شروع به چرخش کردند.',
  100000107:'{userName} داستان ما از اینجا شروع می شود',
  100000108:'با هم به سمت یک رویای مشترک دویدیم.',
  100000109:'ستاره های سرمایه گذاری',
  100000110:'بررسی اجمالی کیف پول سالانه - نرخ بازده کل',
  100000111:'شما از <em class="normal bold {className}" style="color: #2AFF0A;">%</em><em class="normal bold" style="color: #2AFF0A;">{percentage}</em>کاربران پیشی گرفته اید',
  100000112:'در سال گذشته، از <em class="normal bold" style="color: #FFF;">FOMO</em>ناشی از نگارش‌ها لذت بردیم و از خوشحالی <em class="normal bold" style="color: #FFF;">meme رشد</em> برخوردار بودیم. حالا بیایید به خاطرهای شما وارد شویم.',
  100000113:'ستاره های معامله گر',
  100000114:'تراکنش های تجمعی در سال 2024 (بار)',
  100000115:'مبلغ تراکنش تجمعی ($)',
  100000116: 'شما از <em class="normal bold" style="color: #FFC72B;">%</em><em class="normal bold" style="color: #FFC72B;">{percentage}</em> از کاربران پیشی گرفته اید.',
  100000117:'این فقط یک دستاورد عددی نیست، بلکه نشانی از بینش و خرد شماست.',
  100000118:'هر معامله یک گام به سمت Web3.0 است.',
  100000119:'ستاره در حال ظهور',
  100000120:'بزرگترین افت بیت کوین در سال 2024 به <em class="normal">34%</em> درصد رسید. اصلاحات بازار یک هنجار است و عملکرد سرمایه گذاری شما فقط یک مرحله است - پتانسیل بزرگی در پیش است!',
  100000121:'سرمایه گذار ثابت',
  100000122:'هر مشاهده و انتظار برای آماده شدن برای لحظه ای دقیق تر بود. ما مشتاقانه منتظر معجزات سرمایه گذاری و سود شما در سال 2025 هستیم.',
  100000123:'پر معامله ترین توکن در سال 2024',
  100000124:'آنچه را که نگه دارید، بازتاب می یابد.',
  100000125:'تمرکز و تلاش شما قبلاً در نتایج معاملات شما درخشیده است.',
  100000126:'عملکرد بیت کوین در سوپراکس در سال 2024',
  100000127:'نوسانات قیمت Bitcoin شما در سال 2024',
  100000128:'بابت افزایش دارایی هایتان تبریک می گویم! در سال آینده به سرعت خود ادامه دهید.',
  100000129:'در سال 2024، شما بیت کوین را نگه نداشتید.',
  100000130:'سرمایه گذار برجسته',
  100000131:'سرمایه گذار ثابت',
  100000132:'سرمایه گذار یادگیرنده',
  100000133:'داده های معاملاتی بازار اصلی شما',
  100000134:'درآمد($)',
  100000135:'بازده سالانه (%)',
  100000136:'رتبه بندی سود (%)',
  100000137:'داده های معاملاتی فیوچرز شما',
  100000138:'استراتژی تجاری شما خرد شما را به نمایش می گذارد—از اینکه همکاری با ما را انتخاب کردید متشکریم!',
  100000139:'راه اندازی بادبان برای آینده',
  100000140:'شما فقط از روند عقب نمی‌مانید، بلکه پیشگام آن نیز هستید! شما در منطقه آزاد، سکه‌ها را <em class="normal bold" style="color: #FFF;">{num1}</em> بار راه‌اندازی کردید و <em class="normal bold" style="color: #FFF;">{num2}</em> بار معامله کردید. شما که به محصولات نوآورانه علاقه‌مندید، یک ماجراجوی واقعی هستید!！',
  100000141:'ستاره ممتاز اجتماعی',
  100000142:'با تشکر از شما برای آوردن کاربران جدید <em class="normal bold" style="color: #FFF;">{num}</em> به پلت فرم ما. ارجاعات شما باعث رشد ما شده است. ما مشتاقانه منتظر افراد همفکر بیشتری هستیم که در سفر Web3.0 به ما بپیوندند.',
  100000143:'ستاره اجتماعی در حال ظهور',
  100000144:'<em class="normal bold" style="color: #FFF;">{num}</em> کاربر سوپراکس با دعوت از دوستان تا 40% در کمیسیون معاملات کسب کرده اند. اگر در سال 2024 از دست دادید، نگران نباشید - در سال 2025 از فرصت استفاده کنید.',
  100000145:'نکات برجسته سالانه خود را با جامعه خود به اشتراک بگذارید، افراد بیشتری را تشویق کنید که به ما بپیوندند، و در حالی که با هم دنیای ارزهای دیجیتال را کشف می کنید، قفل پاداش های انحصاری را باز کنید!',
  100000146:'یک دوست را دعوت کنید تا جایزه ای به ارزش 10 USDT دریافت کنید!',
  100000147:'گزارش را به اشتراک بگذارید',
  100000148:'مشاهده مجدد',
  100000149: "در سال 2024، شما در SuperEx به عنوان شناخته شده بودید",
  100000150:'شما از کاربران پلتفرم بهتر عمل کردید:',
  100000151:'بازار اصلی معاملات اسپات نرخ بازده سالانه',
  100000152:'قرارداد نرخ بازده سالانه',
  100000153:'امسال، من یک افسانه سرمایه گذاری هستم!',
  100000154:'کد ارجاع: {InviteCode}',
  100000155:"SuperEx.com - وب ۳.۰ صرافی ارز دیجیتال",
  100000156:'پیروزی‌های پایدار،  قدرت آشکار شد!',
  100000157:'تجربه به دست آمده در این سال؛ سال آینده حتی بهتر خواهد بود!',
  100000158:'آیا می دانستید؟',
  100000159:'زون آزاد معاملات نقدی SuperEx، داغ‌ترین و پتانسیل‌ترین پلتفرم معاملات میم‌کوین در جهان است.',
  100000160:'2024، SuperEx یک میلیون <em class="normal bold" style="color: #FFF;">{num}</em> کاربر جدید اضافه می کند، به عنوان خانواده جدید',
  100000161:'مرور 2024 و سفر به سود هزار برابری در 2025 شما به زودی آغاز می‌شود.',
  100000162:'این یک نامه از یک عضو بزرگ خانواده Superex است که در آن اخبار خوش آنها برای سال 2024 ثبت شده است.',
  100000163:'@to*** با 1 USDT موفق به خرید 1 BTC شد، نرخ بازدهی تا <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em> رسید',
  100000164:'@1o***با 1USDT یک عدد ETH کسب کرد، بازدهی به <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em> رسید.',
  100000165:'@we*** یک iPhone 15 را با 1 USDT به دست آورده است، نرخ بازگشت <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em> است',
  100000166:'همچنین چیزهای جالب‌تری وجود دارد…',
  100000167:'سرمایه کم، بازدهی بالا و بازی‌های روز به روز بهتر هر بار مشارکت را پر از شگفتی می‌کند!',
  100000168:'چندمحصول، قرارداد، مدیریت ثروت…',
  100000169:'نامه خیلی طولانی است، بیایید به خواندن ادامه دهیم',
  100000170:'با مجموع بیش از <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150</span> توکن اولیه، جایزه Superex همچنان متعهد به ایجاد فرصت های بیشتر برای کاربران است.',
  100000171:'بررسی کلی سالانه کیف پول حساب نرخ سود تجمعی',
  100000172:'مرور کیف پول حساب سود و زیان سالانه <em class="normal bold {classNum}">{num}</em>',
  100000173:'شما از <em class="normal bold" style="color: #FFF;font-size:1rem;">%</em><em class="normal bold" style="color: #FFF;font-size:1rem;">{percentage}</em> کاربران جلوتر هستید. حکمت شما در استراتژی های سرمایه گذاری شگفت انگیز است.',
  100000174:'2025-SuperEx',
  100000175:'راه ثروت',
  100000176:'زمانی که آماده هستید',
  100000177:'سلام! من دوست جدید SuperEx هستم',
  100000178:'به SuperEx بپیوندید و امکانات بی انتها را کشف کنید. با ثبت نام از مزایای ویژه کاربران جدید بهره مند شوید.',
  100000179:'کاربر@vb*** در معاملات صرافی اصلی اسپات شرکت کرده و نرخ بازده تجمعی $ATOM نزدیک به <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> است.',
  100000180:'کاربر@xi***در تجارت اصلی اسپات $PIPE مشارکت دارد که بازده تجمعی نزدیک به <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em> دارد',
  100000181:'کاربر@09*** در معاملات اصلی اسپات $ATH شرکت می کند که بازده تجمعی آن نزدیک به <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em> است.',
  100000182:'ما از اینکه شهادت دهیم که شما اولین معامله خود را در وب 3 انجام می دهید و فصل هیجان انگیزی را آغاز می کنید، خوشحالیم!',
  100000183:'۱USD Super Start、 ۱۰۰۰ +در سهام، ۱۵۰X سهام، ۱۰۰۰X نوشته',
  100000184:'تجربه بخش‌های با بازدهی بالا را کنید!',
  100000185:'افزایش و کاهش گذرا هستند، اما ایمان همیشگی است.',
  100000186:'از میان نوسانات عبور کنید و شاهد ارزش باشید.',
  100000187:'گزارش سال ۲۰۲۴ شما هنوز ایجاد نشده است. به سفر تجاری سال جدید خوش آمدید! با تعامل بیشتر، می‌توانید جمع‌بندی اختصاصی سال آینده را باز کنید!',
  100000188:'داستان سالانه ارز دیجیتال 2024 منتظر بررسی شماست! لحظات برجسته 2024 را با SuperEx دوباره زنده کنید، بیایید و لحظات منحصر به فرد خود را به اشتراک بگذارید! ',
  100000189:'داستان سالانه ارز دیجیتال 2024 منتظر بررسی شماست!',
  100000190: 'برای مشاهده "گزارش سالانه" برنامه SuperEx را باز کنید',
  100000191: '{year}سال {month}ماه {day}روز (UTC)',
  100000192: '',
  100000193: '',
  100000193: '',
}
export default fa


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/fa.js